var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "60px",
    height: "60px",
    viewBox: "610 370 60 60",
    enableBackground: "new 610 370 60 60",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    opacity: 0.25,
    enableBackground: "new    "
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#2F3A4F",
    d: "M640,428.807c-1.018,0-2.137-0.509-2.646-1.63l-2.443-3.357c-12.418-2.442-21.478-13.029-21.478-26.06 c0-14.658,11.91-26.567,26.567-26.567c14.657,0,26.567,11.909,26.567,26.567c0,13.03-9.06,23.617-21.478,26.06l-2.342,3.46 C642.139,427.991,641.019,428.807,640,428.807z M640,373.839c-13.232,0-23.921,10.586-23.921,23.92 c0,11.707,8.245,21.479,19.952,23.412h0.508l2.952,4.479c0.306,0.509,0.815,0.509,1.018,0l2.951-4.479h0.509 c11.401-1.831,19.953-11.705,19.953-23.412C663.922,384.426,653.233,373.839,640,373.839z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M665.243,397.76c0-13.843-11.4-25.244-25.243-25.244c-13.843,0-25.245,11.4-25.245,25.244 c0,12.521,9.06,22.803,20.97,24.736l2.646,4.275c0.814,1.322,2.34,1.322,3.155,0l2.647-4.275 C656.185,420.563,665.243,410.18,665.243,397.76z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#2F3A4F",
    cx: 640,
    cy: 397.761,
    r: 22.09
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FF4343",
    cx: 640,
    cy: 397.76,
    r: 18.628
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M649.06,388.6c-0.306-0.816-1.019-1.324-1.833-1.324h-14.352c-0.814,0-1.628,0.508-1.832,1.324 l-2.749,7.838v10.484c0,0.712,0.611,1.323,1.323,1.323h1.223c0.712,0,1.323-0.611,1.323-1.323v-1.323h15.676v1.323 c0,0.712,0.609,1.323,1.324,1.323h1.322c0.713,0,1.323-0.611,1.323-1.323v-10.484L649.06,388.6z M632.875,401.629 c-1.12,0-1.934-0.917-1.934-1.934c0-1.121,0.916-1.936,1.934-1.936s1.934,0.917,1.934,1.936 C634.809,400.814,633.893,401.629,632.875,401.629z M647.125,401.629c-1.119,0-1.935-0.917-1.935-1.934 c0-1.121,0.917-1.936,1.935-1.936c1.019,0,1.935,0.917,1.935,1.936C649.162,400.814,648.245,401.629,647.125,401.629z  M630.839,395.114l2.035-5.803h14.25l1.935,5.903L630.839,395.114L630.839,395.114z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCar);
export default __webpack_public_path__ + "static/media/car.48ad4d2406fb378f1bebdda3bb57df95.svg";
export { ForwardRef as ReactComponent };